import { useContext } from "react"
import { NoData, NoEvents } from "@components"
import { UserContext, useTheme } from "@context"
import { hasOrganiserRights } from "@helpers"
import { Navigate } from "react-router-dom"

const Home = () => {
  const { user } = useContext(UserContext)
  const { theme } = useTheme()

  if (hasOrganiserRights(user) && (!user?.me?.client.imported_at || !user?.dataCounts?.is_complete) && user?.me?.client?.importType?.code !== "DEMO") {
    return <NoData theme={theme} />
  }

  if (!user?.me.defaultEvent) {
    return <NoEvents />
  }

  if (user?.me?.defaultEvent) {
    if (hasOrganiserRights(user)) {
      return <Navigate to={`/event/${user.me.defaultEvent.id}/dashboard`} replace />
    }

    return <Navigate to={`/event/${user.me.defaultEvent.id}/schedule`} replace />
  }
}

export default Home
